module.exports = __webpack_public_path__ + "img/connection-0.e3020f3f.svg";